module.exports = __webpack_public_path__ + "img/elementheights_jas.28b20ff4.png";